<template>
  <span>
    <side-bar v-if="showAdminMenu" />
    <div class="pt-4" />
  </span>
</template>

<script>
import SideBar from '@/components/SideBar';
export default {
  name: 'AdminLayout',
  components: {
    SideBar,
  },
  computed: {
    showAdminMenu: function () {
      return this.$route.path.includes('/admin');
    },
  },
};
</script>

<style scoped></style>
